import React, { useCallback } from 'react';
import { FormGroup, FormSelect } from '~/components/form';
import { ownerEntityType } from '~/api';
import { useForm } from '~/hooks';


export const InsuredEntity= (props) => {

    const {
        onInsuredIndividualChange,
        detailData
    } = props;

    const defaultState = {
        insuredEntityName: detailData? detailData.insuredEntityName : '',
        insuredEntityType: detailData? detailData.insuredEntityType : { label: '...', value: '' }
    };

    const loadData = () => async (values) => {
        const insuredEntityTypeOptions = (await ownerEntityType.getOwnerEntityTypes()).map(f => ({
            label: f.label, value: f.value
        }));
        return {
            ...values,
            insuredEntityTypeOptions
        };
    };
    
    const onLoad = useCallback(loadData(), []);

    const { state, fieldActions } = useForm({
        initialState: { ...defaultState },
        onLoad
    });

    return (
        <div className="row grid grid-cols-4 grid-flow-row gap-x-2 gap-y-4 text-sm mb-4">  
            <FormGroup
                label="Entity Name"
                required
                groupClassName="col-span-2"
                inputClassName="w-full border-1 border-gray-200 rounded bg-gray-50"
                path='insuredEntityName'
                value={state.values.insuredEntityName}
                error={state.errors.insuredEntityName}
                maxLength={36}
                validator={value=> value.length < 36 ? true : state.values.insuredEntityName && 'Entity Name cannot be more than 36 characters.'}  
                
                {...fieldActions}
                onChange={(value) => {
                    fieldActions.onChange(value, 'insuredEntityName');   
                    onInsuredIndividualChange(state.values);                 
                }}
            />
            <FormSelect
                label="Entity Type"
                type='select'
                required
                options={state.values.insuredEntityTypeOptions}
                isClearable={false}
                isSearchable
                groupClassName="col-span-2"
                className="w-full border-1 border-gray-200 rounded bg-gray-50"
                path='insuredEntityType'   
                value={state.values.insuredEntityType}
                error={state.errors.insuredEntityType}
                {...fieldActions}
                onChange={(insuredEntityType) => {
                    fieldActions.onChange(insuredEntityType, 'insuredEntityType');
                    fieldActions.onChange({ label: '...', value: ''}, 'requestedBy');  
                    onInsuredIndividualChange(state.values);                      
                }}                             
            />     
        </div>
    );
};
